export enum EditType {
  quantity,
  price,
  triggerPrice,
  callbackValue,
  callbackRate,
}
